const zhTW = {
  common: {
    welcome: '歡迎使用 WYNI AI ERP',
    login: '登入',
    email: '電子郵件',
    password: '密碼',
    dashboard: '儀表板',
    users: '用戶管理',
    products: '產品管理',
    orders: '訂單管理',
    reports: '報表中心',
    settings: '系統設定',
    revenue: '營業額',
    // Additional translations
    search: '搜尋',
    add: '新增',
    edit: '編輯',
    delete: '刪除',
    save: '儲存',
    cancel: '取消',
    confirm: '確認',
    back: '返回',
    loading: '載入中...',
    noData: '暫無資料',
    error: '錯誤',
    success: '成功',
  },
  auth: {
    login_success: '登入成功',
    login_failed: '登入失敗',
    logout_success: '登出成功',
  },
};

export default zhTW; 